import { getVisibilityColumns } from '@components/ColumnsVisibilityToggle/getVisibilityColumns';

import columns from './columns';

const documentsVisibilityColumns = getVisibilityColumns(columns([]));

export { documentsVisibilityColumns };
